// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"635":"0e3338ee","913":"0e3338ee"}[chunkId] + ".chunk.css";
};